<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('bill.set_block_account')}}</div>
    <div slot="body">
      <a-alert class="mb-2" type="warning" :message="$t('bill.block_account_tip')" />
      <dialog-selected-tips :count="params.data.length" :action="$t('bill.set_block_account')" :name="$t('bill.accounting_period')" />
      <dialog-table :data="params.data" :columns="params.columns" />
      <a-form-model :model="form" :rules="rules" ref="form" v-bind="formItemLayout">
        <a-form-model-item :label="$t('bill.block_account_status')">
          <a-radio-group v-model="form.action">
            <a-radio value="enable">{{$t('bill.block_account')}}</a-radio>
            <a-radio value="disable">{{$t('bill.unblock_account')}}</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button  @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
// import expectStatus from '@/constants/expectStatus'

export default {
  name: 'SetBlockAccountDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    const { enabled } = this.params.data[0]
    return {
      loading: false,
      form: {
        action: enabled ? 'enable' : 'disable',
      },
      formItemLayout: {
        wrapperCol: {
          span: 21,
        },
        labelCol: {
          span: 3,
        },
      },
    }
  },
  computed: {
    ...mapGetters(['scope']),
  },
  created () {
  },
  methods: {
    async handleConfirm () {
      this.loading = true
      try {
        await this.params.onManager('batchPerformAction', {
          id: this.params.data.map(item => item.id),
          managerArgs: {
            action: this.form.action,
          },
        })
        this.params.refresh && this.params.refresh()
        this.cancelDialog()
        this.$message.success(this.$t('compute.text_423'))
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
